import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import './PolicyPages.css';

const TermsConditions = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="policy-page">
      {/* Header */}
      <div className="policy-header">
        <div className="policy-header-content">
          <button className="back-button" onClick={handleGoBack}>
            <ArrowLeft size={20} />
            <span>Back</span>
          </button>
          <div className="policy-title-section">
            <div className="policy-icon">
              <FileText size={32} />
            </div>
            <h1>Terms & Conditions</h1>
            <p>IPH Pharmaceuticals – Malaysia</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="policy-content">
        <div className="policy-container">

          {/* Main Content */}
          <div className="policy-main-content">

            <section className="policy-section">
              <div className="policy-text">
                <p>
                  Please read these Terms carefully before using our website or purchasing our products. By accessing or using our services, you agree to be bound by these Terms.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>1. Products & Use</h2>
              <div className="policy-text">
                <p>
                  IPH Pharmaceuticals is the sole distributor of Chalmers Dale products in South East Asia. All products are intended for cosmetic and personal care purposes only and are not meant to diagnose, treat, or prevent any medical condition.
                </p>
                <p>
                  Customers are responsible for reviewing product information and ensuring suitability before purchase.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>2. Orders & Payment</h2>
              <div className="policy-text">
                <p>
                  All orders are subject to product availability and acceptance. We reserve the right to cancel or refuse any order due to pricing errors, stock limitations, or suspected fraudulent activity.
                </p>
                <p>
                  Payments are processed through secure gateways. We do not store credit card or payment details.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>3. Intellectual Property</h2>
              <div className="policy-text">
                <p>
                  All website content, including branding, images, and product descriptions, is owned by IPH Pharmaceuticals or its licensors. Reproduction or distribution without permission is prohibited.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>4. Privacy</h2>
              <div className="policy-text">
                <p>
                  We are committed to protecting your personal data in accordance with the Malaysian Personal Data Protection Act (PDPA). Information collected is used only for order fulfilment, communication, and customer service.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>5. Disclaimer & Liability</h2>
              <div className="policy-text">
                <p>
                  Products and website information are provided on an “as is” basis. To the fullest extent permitted by law, IPH Pharmaceuticals shall not be liable for indirect or consequential damages, including adverse skin reactions or misuse of products.
                </p>
                <p>
                  This does not affect your rights under Malaysian consumer protection laws.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>6. Changes to Terms</h2>
              <div className="policy-text">
                <p>
                  We reserve the right to update these Terms at any time. Continued use of the website constitutes acceptance of any updates.
                </p>
              </div>
            </section>

            <section className="policy-section">
              <h2>7. Governing Law</h2>
              <div className="policy-text">
                <p>
                  These Terms are governed by the laws of Malaysia.
                </p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
